import { Component, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { BirthdayEmailModal } from '../email-modals/birthday/birthday-email-modal';
import { GeneralEmailModal } from '../email-modals/general/general-email-modal';

type EmailType = 'birthday' | 'general';

@Component({
  selector: 'via-email-icon',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './email-icon.component.html',
})
export class EmailIconComponent {
  @Input() emailType: EmailType = 'general';

  private dialog = inject(MatDialog);

  onClick() {
    switch (this.emailType) {
      case 'birthday': {
        this.dialog.open(BirthdayEmailModal, {
          width: 'min(720px, 92vw)',
          maxWidth: '92vw',
          height: 'min(670px, 90vh)',
          maxHeight: '90vh',
        });
        break;
      }
      case 'general': {
        this.dialog.open(GeneralEmailModal, {
          width: 'min(720px, 92vw)',
          maxWidth: '92vw',
          height: 'min(670px, 90vh)',
          maxHeight: '90vh',
        });
      }
    }
  }
}
